import React from 'react';
import { NavItem, Service, Testimonial, Article } from './types';
import { Plane, Briefcase, GraduationCap, MapPin, Anchor, BookOpen, UserCheck, Globe } from 'lucide-react';

// Keeping Westkin Design Colors for the requested look
export const BRAND_COLORS = {
  primary: '#009B8F', // Westkin Teal
  secondary: '#011E26', // Deep Dark Green/Black
  accent: '#F3F4F6',
};

export const NAV_ITEMS: NavItem[] = [
  {
    label: 'Admissions',
    href: '#admissions',
    subItems: [
      { label: 'Course Matching', link: '/admissions/course-matching' },
      { label: 'Admissions Engine', link: '/admissions/admissions-engine' },
      { label: 'Application Tracker', link: '/admissions/application-tracker' },
      { label: 'Scholarship Finder', link: '/admissions/scholarship-finder' },
      { label: 'Global Destination Analytics', link: '/admissions/destination-analytics' },
    ]
  },
  {
    label: 'English Prep Hub',
    href: '#english-prep-lab',
    subItems: [
      { label: 'AI English Diagnostics', link: '/english-prep-lab/diagnostics' },
      { label: 'AI Voice Coach', link: '/english-prep-lab/voice-coach' },
      { label: 'Automated Study Paths', link: '/english-prep-lab/study-paths' },
    ]
  },
  {
    label: 'Immigration & Legal',
    href: '#legal',
    subItems: [
      { label: 'Visa Probability Scoring', link: '/immigration/probability-scoring' },
      { label: 'Automated Compliance Engine', link: '/immigration/compliance-engine' },
      { label: 'Immigration Milestone Tracker', link: '/immigration/milestone-tracker' },
      { label: 'Connect with Immigration Solicitors', link: '/immigration/solicitors' },
    ]
  },
  {
    label: 'Transport',
    href: '#travel',
    subItems: [
      { label: 'Flight Booking Assistance', link: '/transport/flight-booking' },
      { label: 'Airport Pickup & Drop-off', link: '/transport/airport-pickup' },
      { label: 'Local Transport Guidance', link: '/transport/local-transport' },
      { label: 'Vehicle Assistance & Rentals', link: '/transport/vehicle-assistance' },
    ]
  },
  {
    label: 'AI Accommodation Matcher',
    href: '#accommodation',
    subItems: [
      { label: 'Safety & Location Advice', link: '/eligibility?service=accommodation' },
      { label: 'Accommodation Guidance', link: '/eligibility?service=accommodation' },
      { label: 'Temporary Housing Support', link: '/eligibility?service=accommodation' },
      { label: 'Long-Term Rental Assistance', link: '/eligibility?service=accommodation' },
    ]
  },
  {
    label: 'About',
    href: '#about',
    subItems: [{ label: 'About Nex Overseas', link: '/about' }]
  },
];

export const SERVICES: Service[] = [
  {
    id: 'admissions',
    title: 'Admissions',
    icon: <GraduationCap className="w-8 h-8 text-white" />,
    description: 'Expert guidance for University and College admissions, course selection, and application support.',
    link: '#admissions'
  },
  {
    id: 'english-prep-lab',
    title: 'English Prep Hub',
    icon: <BookOpen className="w-8 h-8 text-white" />,
    description: 'Master English with AI diagnostics, voice coaching, and automated personalized study paths.',
    link: '#english-prep-lab'
  },
  {
    id: 'visa',
    title: 'Visa',
    icon: <MapPin className="w-8 h-8 text-white" />,
    description: 'Specialized visa guidance for students, dependents, and families, including compliance support.',
    link: '#visa'
  },
  {
    id: 'accommodation',
    title: 'AI Accommodation Matcher',
    icon: <Anchor className="w-8 h-8 text-white" />, // Using Anchor for Accommodation as placeholder, usually Home/House icon is better but sticking to imports
    description: 'Full support for student accommodation, temporary housing, and long-term rentals.',
    link: '#accommodation'
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 1,
    name: "Sarah Jenkins",
    visaType: "Canada Student Visa",
    message: "NexOverseas made my university application process seamless. The course selection guidance was spot on!",
    image: ""
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    visaType: "UK Student Visa",
    message: "The coaching for IELTS was excellent. I got the band score I needed for my dream university.",
    image: ""
  },
  {
    id: 3,
    name: "Elena Rodriguez",
    visaType: "Accommodation Support",
    message: "Found great student housing thanks to their accommodation placement service. Safe and convenient!",
    image: ""
  }
];

export const LATEST_NEWS: Article[] = [
  {
    id: 1,
    title: "Canada announces new category-based selection for Express Entry",
    date: "Oct 24, 2024",
    category: "Immigration News",
    image: ""
  },
  {
    id: 2,
    title: "Australia reviews skilled migration list for 2025",
    date: "Oct 22, 2024",
    category: "Visa Updates",
    image: ""
  },
  {
    id: 3,
    title: "Germany introduces Opportunity Card for skilled workers",
    date: "Oct 20, 2024",
    category: "Work Overseas",
    image: ""
  }
];